// Organize your paths here.
// If you need to link to a path with params in it,
// use the pathWithParams function!

export const homePath = "/";
export const redirectPath = "/";
export const welcomePath = "/welcome";
export const uploadingPath = "/uploading";
export const profilePath = "/profile";
export const imprintPath = "/imprint";
export const termsAndConditionsPath = "/termsandconditions";

export const pathWithParams = (
  path: string,
  params: Record<string, string> = {}
): string => {
  const keys = Object.keys(params);
  return keys.reduce((pathUrl, currKey) => {
    const decoratedUrlParam = `:${currKey}`;
    if (pathUrl.indexOf(decoratedUrlParam) > -1) {
      return pathUrl.replace(decoratedUrlParam, params[currKey]);
    }

    return pathUrl;
  }, path);
};
